import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const CountriesRepository = RepositoryFactory.get("countries");

const state = {
  countries: [],
  country: {},
};

const getters = {
  getCountries: () => state.countries,
  getCountry: () => state.country,
};

const actions = {
  getCountries({ commit, dispatch, state }, params = {}) {
    CountriesRepository.getCountries(params)
      .then((response) => {
        const countries = response.data.results;

        commit("SAVE_COUNTRIES", countries);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.countries.getCountriesError`,
            ),
          },
          { root: true },
        );
      });
  },
  getCountry({ dispatch, commit }, id) {
    return CountriesRepository.getCountry(id)
      .then((response) => {
        const country = response.data;
        commit("SAVE_COUNTRY", country);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.countries.getCountryError`,
            ),
          },
          { root: true },
        );
      });
  },
  updateCountry({ dispatch, commit }, payload) {
    const id = payload.id;

    return CountriesRepository.updateCountry(id, payload)
      .then((response) => {
        const country = response.data;
        commit("SAVE_COUNTRY", country);

        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(
              `message.notifications.countries.updateCountrySuccess`,
            ),
          },
          { root: true },
        );
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.countries.updateCountryError`,
            ),
          },
          { root: true },
        );
      });
  },
  createCountry({ commit, dispatch }, payload) {
    CountriesRepository.createCountry(payload)
      .then((response) => {
        const country = response.data;
        commit("SAVE_COUNTRY", country);

        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(
              `message.notifications.countries.createCountrySuccess`,
            ),
          },
          { root: true },
        );
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.countries.createCountryError`,
            ),
          },
          { root: true },
        );
      });
  },
};

const mutations = {
  SAVE_COUNTRIES(state, countries) {
    state.countries = countries;
  },
  SAVE_COUNTRY(state, country) {
    state.country = country;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
